"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Input = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Input = require("./Input.styled");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _excluded = ["name", "type", "placeholder", "id", "error"];
var Input = exports.Input = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var name = props.name,
    type = props.type,
    placeholder = props.placeholder,
    id = props.id,
    error = props.error,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Input.StyledInputWrapper, null, /*#__PURE__*/_react["default"].createElement(_Input.StyledInput, (0, _extends2["default"])({
    id: id,
    name: name,
    type: type,
    placeholder: placeholder,
    invalid: error !== null,
    innerRef: ref
  }, rest)), error && /*#__PURE__*/_react["default"].createElement(_Input.StyledIcon, {
    icon: _freeSolidSvgIcons.faTimes
  })), error && /*#__PURE__*/_react["default"].createElement(_Input.StyledFormFeedback, null, error.message));
});
Input.defaultProps = {
  id: '',
  name: '',
  type: 'text',
  placeholder: 'Placeholder text',
  error: null,
  bsSize: 'lg'
};
Input.propTypes = {
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  type: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  error: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    message: _propTypes["default"].string
  }),
  bsSize: _propTypes["default"].oneOf(['sm', 'md', 'lg'])
};
var _default = exports["default"] = Input;